import { PlayerDataState, PlayerActionTypes, PlayerCreateAction } from "../../types/auth/playerData";

const initialState: PlayerDataState = {
    playerData: null,
    loading: false,
    confirmOTPError: null,
};

export const getPlayerReducer = (
    state = initialState,
    action: PlayerCreateAction,
): PlayerDataState => {
    switch (action.type) {
        case PlayerActionTypes.GET_PLAYER_DATA:
            return { ...state, loading: true, confirmOTPError: null, playerData: null };

        case PlayerActionTypes.GET_PLAYER_DATA_SUCCESS:
            return { ...state, loading: false, confirmOTPError: null, playerData: action.payload };

        case PlayerActionTypes.GET_PLAYER_DATA_ERROR:
            return { ...state, loading: false, confirmOTPError: action.payload, playerData: null };

        default:
            return state;
    }
};